<template>
    <div class="sidebar">
        <nav class="sidebar-nav">
            <ul class="nav">
                <li class="nav-item">
                    <router-link :to="'/dashboard'" class="nav-link"><i class="fa fa-home"></i> {{ $t('pages.dashboard')
                        }}
                    </router-link>
                </li>
                <li class="nav-title">
                    {{ $t('pages.statistic') }}
                </li>
                <li class="nav-item" v-if="haveAccess(Config.STATISTICS.CONVERSIONS)">
                    <router-link :to="'/statistic/conversions/country'" class="nav-link"><i class="fa fa-table"></i>
                        {{ $t('pages.conversions') }}
                    </router-link>
                </li>
                <!--<li class="nav-item" v-if="haveAccess(Config.STATISTICS.WEBMASTERS)">
                    <router-link :to="'/statistic/webmasters'" class="nav-link"><i class="fa fa-internet-explorer"></i>
                        {{ $t('pages.webmasters') }}
                    </router-link>
                </li>-->
                <router-link tag="li" class="nav-item nav-dropdown" :to="'/statistic/webmasters'" disabled  v-if="haveAccess(Config.STATISTICS.WEBMASTERS) || haveAccess(Config.STATISTICS.WEBMASTERS_PAYMENTS)">
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-internet-explorer"></i>
                        {{ $t('pages.webmasters') }}
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item" v-if="haveAccess(Config.STATISTICS.WEBMASTERS)">
                            <router-link :to="'/statistic/webmasters'" class="nav-link" exact><i class="fa fa-table"></i> {{ $t('pages.webmaster_statistic') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="haveAccess(Config.STATISTICS.WEBMASTERS_PAYMENTS)">
                            <router-link :to="'/statistic/webmasters/payments'" class="nav-link" exact>
                                <i class="fa fa-columns icons-big"></i> <span class="menu-title-big">{{ $t('pages.individual_rates') }}</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="'/statistic/webmasters/source'" class="nav-link" exact>
                                <i class="fa fa-columns icons-big"></i> <span class="menu-title-big">{{ $t('pages.source_statistic') }}</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="'/statistic/webmasters/landing'" class="nav-link" exact>
                                <i class="fa fa-columns icons-big"></i> <span class="menu-title-big">{{ $t('pages.landing_statistic') }}</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="'/statistic/webmasters/arrival_new_leads\n'" class="nav-link" exact>
                                <i class="fa fa-columns icons-big"></i> <span class="menu-title-big">{{ $t('pages.arrival_new_leads') }}</span>
                            </router-link>
                        </li>
                      <li class="nav-item">
                        <router-link :to="'/statistic/webmasters/grid'" class="nav-link" exact>
                          <i class="fa fa-columns icons-big"></i> <span class="menu-title-big">{{ $t('pages.grid_statistic') }}</span>
                        </router-link>
                      </li>
                    </ul>
                </router-link>
                <li class="nav-item" v-if="haveAccess(Config.STATISTICS.OFFER_RENTABILITY)">
                    <router-link :to="'/statistic/offer'" class="nav-link"><i class="fa fa-percent"></i>
                        {{ $t('pages.offer') }}
                    </router-link>
                </li>
                <li class="nav-item" v-if="haveAccess(Config.STATISTICS.RETURN_REASON)">
                    <router-link :to="'/statistic/refunds'" class="nav-link"><i class="fa fa-undo"></i>
                        {{ $t('pages.refunds') }}
                    </router-link>
                </li>
                <li class="nav-item" v-if="haveAccess(Config.STATISTICS.BUYOUT)">
                    <router-link :to="'/statistic/buyout'" class="nav-link"><i class="fa fa-dollar"></i>
                        {{ $t('pages.buyout') }}
                    </router-link>
                </li>
                <!--<li class="nav-item" v-if="haveAccess(Config.STATISTICS.RETURN_REASON)">
                    <router-link :to="'/statistic/return-reason'" class="nav-link"><i class="fa fa-reply-all"></i>
                        {{ $t('pages.return_reason') }}
                    </router-link>
                </li>-->
                <router-link tag="li" class="nav-item nav-dropdown" :to="'/statistic/operators'" disabled
                             v-if="haveAccess(Config.STATISTICS.OPERATORS_EFFICIENCY) || haveAccess(Config.STATISTICS.OPERATORS_ACTIVITY) || haveAccess(Config.STATISTICS.ORDER_PROCESSING)">
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-phone"></i>
                        {{ $t('pages.operators') }}
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.OPERATORS_EFFICIENCY)">
                            <router-link :to="'/statistic/operators/efficiency'" class="nav-link" exact><i
                                    class="fa fa-bolt"></i> {{ $t('pages.efficiency') }}
                            </router-link>
                        </li>
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.OPERATORS_ACTIVITY)">
                            <router-link :to="'/statistic/operators/activity'" class="nav-link" exact><i
                                    class="fa fa-tachometer"></i> {{ $t('pages.activity') }}
                            </router-link>
                        </li>
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.ORDER_PROCESSING)">
                            <router-link :to="'/statistic/operators/order'" class="nav-link" exact><i
                                    class="fa fa-cube"></i> {{ $t('pages.order') }}
                            </router-link>
                        </li>
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.OPERATORS_SUMMARY)">
                            <router-link :to="'/statistic/operators/conversions/conversion'" class="nav-link" exact><i
                                    class="fa fa-calculator"></i> {{ $t('pages.conversion') }}
                            </router-link>
                        </li>
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.OFFER_ACTIVITY_STATISTIC)">
                            <router-link :to="'/statistic/operators/schedule'" class="nav-link" exact><i
                                    class="fa fa-clock-o"></i> {{ $t('pages.approved_during_the_day') }}
                            </router-link>
                        </li>
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.EXPENSE_EXPECTION)">
                            <router-link :to="'/statistic/operators/expenses_kc'" class="nav-link" exact><i
                                    class="fa fa-clock-o"></i> {{ $t('pages.expenses_by_kc') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="haveAccess(Config.STATISTICS.CALL_CENTER_TIMINGS)">
                            <router-link :to="'/statistic/operators/timing_kc'" class="nav-link" exact><i
                                    class="fa fa-clock-o"></i> {{ $t('pages.timing_kc') }}
                            </router-link>
                        </li>
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.EXPENSE_EXPECTION)">
                            <router-link :to="'/statistic/operators/ringing_sms'" class="nav-link" exact><i
                                    class="fa fa-clock-o"></i> {{ $t('pages.ringing_sms') }}
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/statistic/operators/call_statistics'" class="nav-link" exact><i
                                    class="fa fa-clock-o"></i> {{ $t('pages.call_statistics') }}
                            </router-link>
                        </li>
                        <li class="nav-item"
                            v-if="haveAccess(Config.STATISTICS.HOLD_CALLS)">
                            <router-link :to="'/statistic/operators/ringing_holds'" class="nav-link" exact><i
                                    class="fa fa-clock-o"></i> {{ $t('pages.ringing_holds') }}
                            </router-link>
                        </li>
                      <li class="nav-item">
                        <router-link :to="'/statistic/operators/cross_sell'" class="nav-link" exact><i
                            class="fa fa-cube"></i> {{ $t('pages.cross_sell') }}
                        </router-link>
                      </li>
                    </ul>
                </router-link>
                <li class="nav-item" >
                    <router-link :to="'/statistic/product'" class="nav-link"><i class="fa fa-archive"></i>
                        {{ $t('pages.product') }}
                    </router-link>
                </li>
                <!--<router-link tag="li" class="nav-item nav-dropdown" :to="'/statistic/product'" disabled-->
                    <!--v-if="haveAccess(Config.STATISTICS.OPERATORS_EFFICIENCY)">-->
                    <!--<div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-archive"></i>-->
                        <!--{{ $t('pages.product') }}-->
                    <!--</div>-->
                    <!--<ul class="nav-dropdown-items">-->
                        <!--<li class="nav-item"-->
                            <!--v-if="haveAccess(Config.STATISTICS.ORDER_PROCESSING)">-->
                            <!--<router-link :to="'/statistic/product/remnants'" class="nav-link" exact><i-->
                                    <!--class="fa fa-archive"></i> {{ $t('pages.remnants') }}-->
                            <!--</router-link>-->
                        <!--</li>-->
                        <!--<li class="nav-item"-->
                            <!--v-if="haveAccess(Config.STATISTICS.OPERATORS_EFFICIENCY)">-->
                            <!--<router-link :to="'/statistic/product/orders'" class="nav-link" exact><i-->
                                    <!--class="fa fa-money"></i> {{ $t('pages.orders') }}-->
                            <!--</router-link>-->
                        <!--</li>-->
                        <!--<li class="nav-item"-->
                            <!--v-if="haveAccess(Config.STATISTICS.OPERATORS_ACTIVITY)">-->
                            <!--<router-link :to="'/statistic/product/receipt'" class="nav-link" exact><i-->
                                    <!--class="fa fa-money"></i> {{ $t('pages.receipt') }}-->
                            <!--</router-link>-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</router-link>-->

                <!--<li class="nav-item" v-if="Storage.developMode">
                    <router-link :to="'#page_uri'" class="nav-link"><i class="fa fa-code" aria-hidden="true"></i>
                        {{ $t('pages.dev_editor') }}
                    </router-link>
                </li>-->

            </ul>
        </nav>
    </div>
</template>
<script>

  import Config from '@/Config'
  import Auth from '@/api/Auth'
  import Storage from '@/api/Storage'

  export default {
    name: 'sidebar',
    methods: {
      handleClick (e) {
        e.preventDefault()
        e.target.parentElement.classList.toggle('open')
      },
      haveAccess (statisticName) {
        return Auth.user.profile.allowed_statistics[Config.STATISTICS[statisticName]]
      }
    },
    data () {
      return {
        Config: Config,
        Storage: Storage
      }
    }
  }
</script>

<style lang="css">
    .nav-link {
        cursor: pointer;
    }
    .icons-big{
        position: absolute;
        top: 16px;
    }
    .menu-title-big{
        display: inline-block;
        padding-left: 30px
    }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?15e1ad22